@if (isAdmin) {
  <div class="btn-container">
    <button pButton pRipple type="button" label="New Order" icon="pi pi-plus"
    (click)="openOrderDialog('create')"></button>
  </div>
}
<div class="table-container">
  <p-table #dt [value]="allNursingOrders" styleClass="p-datatable" [loading]="isLoading" [rowHover]="true" [rows]="5"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="simDateCreated">
          <div class="flex justify-content-between align-items-center">
            Date/Time
            <p-sortIcon field="simDateCreated"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="title">
          <div class="flex justify-content-between align-items-center">
            Title
            <p-sortIcon field="title"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="signature">
          <div class="flex justify-content-between align-items-center">
            Signature
            <p-sortIcon field="signature"></p-sortIcon>
          </div>
        </th>
        <!--
        <th *ngIf="isAdmin" pSortableColumn="dateCreated">
          <div class="flex justify-content-between align-items-center">
            Date Created
            <p-sortIcon field="dateCreated"></p-sortIcon>
          </div>
        </th>
        -->
        <th>
          <div class="flex justify-content-between align-items-center">
            <div class="actions-title-container">Actions</div>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="p-selectable-row">
        <td>
          {{ order.datetimeString }}
        </td>
        <td>
          {{ order.title }}
        </td>
        <td>
          {{ order.signature }}
        </td>
        <!--
        <td *ngIf="isAdmin">
          {{ order.dateCreatedString }}
        </td>
        -->
        <td class="actions-container">
          <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View order"
          (click)="viewOrder(order)"></button>
          @if (isAdmin) {
            <button pButton type="button" class="p-button-warning" icon="pi pi-pencil"
            pTooltip="Edit order" (click)="openOrderDialog('edit', order)"></button>
          }
          @if (isAdmin) {
            <button pButton type="button" class="p-button-danger" icon="pi pi-trash"
            pTooltip="Delete order" (click)="deleteOrder(order)"></button>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>